import { render, staticRenderFns } from "./BlogPostsReadMore.vue?vue&type=template&id=75548330&"
import script from "./BlogPostsReadMore.vue?vue&type=script&lang=js&"
export * from "./BlogPostsReadMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports